import state from "./state";

export default {
    LOGOUT_USER(state) {
        state.activeUser = {};
        localStorage.removeItem(state.localUserKey);
        window.location.replace(`${state.domain}/logout`)
    },
    TOGGLE_LOADER(state, loader) {
        state.layout.loader = loader;
    },
    SET_AUTH_TOKEN(state, data){
        const expirationTime = new Date( new Date().getTime() + +data.expiresIn * 1000);
        const config = {
            token: data.accessToken,
            tokenExpirationDate: expirationTime.toISOString(),
            user: data.user,
        }
        state.activeUser = {...data.user};
        const encryptedValue = btoa(escape(JSON.stringify(config)));
        localStorage.setItem(state.localUserKey, encryptedValue);
    },
    UPDATE_USER_INFO(state, user) {
        if(!user.id){return};
        state.activeUser = {...user};
        const get_localUser = localStorage.getItem(state.localUserKey);
        const storedData = JSON.parse(unescape(atob(get_localUser)));
        storedData.user = user;
        localStorage.setItem(state.localUserKey, btoa(escape(JSON.stringify(storedData))));
    },
    SET_PROJECT(state, project){
        state.project = {...project}
    },
    SET_PRODUCT(state, product){
        state.product = {...product}
    },
    SET_COUNTRY(state, country){
        state.country = {...country}
    }
}
